import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminEditCouponPage = React.lazy(() => import(/* webpackChunkName: "AdminEditCoupon" */ './Page'));
export const AdminEditCoupon = () => (React.createElement(Page, { title: "Administrator Edit Coupon" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminEditCouponPage, null)))));
